var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaultYield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 187,
    viewBox: "0 0 188 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_2321",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 188,
    height: 187
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_2321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5633 179.416H-10.125C-13.3367 179.416 -16 176.767 -16 173.573V133.679C-16 125.576 -9.34175 118.952 -1.19508 118.952H19.5633C22.7749 118.952 25.4383 121.601 25.4383 124.796V173.494C25.4383 176.766 22.7749 179.416 19.5633 179.416ZM-4.25 167.729H13.6882V130.718H-1.19508C-2.84008 130.718 -4.25 132.042 -4.25 133.756V167.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1677 179.416H19.4794C16.2678 179.416 13.6045 176.767 13.6045 173.573V98.3045C13.6045 90.2011 20.2627 83.5781 28.4094 83.5781H40.3161C48.4627 83.5781 55.1211 90.2011 55.1211 98.3045V173.573C55.0427 176.767 52.4577 179.416 49.1677 179.416ZM25.4327 167.729H43.3711V98.3045C43.3711 96.6682 42.0394 95.2656 40.3161 95.2656H28.4094C26.7644 95.2656 25.3544 96.5903 25.3544 98.3045V167.729H25.4327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8641 179.417H49.1758C45.9641 179.417 43.3008 176.767 43.3008 173.573V138.12C43.3008 134.925 45.9641 132.276 49.1758 132.276H69.9341C78.0808 132.276 84.7391 138.899 84.7391 147.002V173.573C84.7391 176.767 82.1541 179.417 78.8641 179.417ZM55.0508 167.729H72.9891V147.002C72.9891 145.366 71.6574 143.964 69.9341 143.964H55.0508V167.729Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_2321)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_79_2321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.36523,
    y: 54,
    width: 336,
    height: 161,
    rx: 16,
    fill: "url(#paint0_linear_79_2321)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_79_2321",
    x: -13.6348,
    y: 34,
    width: 376,
    height: 201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_79_2321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_79_2321",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_2321",
    x1: 15.5289,
    y1: 215,
    x2: 324.636,
    y2: 25.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253125,
    stopColor: "#BC85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758333,
    stopColor: "#5CC6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_2321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 187,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultYield);
export default __webpack_public_path__ + "static/media/vaultYield.f9cf763dc34f2abd557ff9ced7ea8daa.svg";
export { ForwardRef as ReactComponent };